<div class="category-modal-body" data-testid="analysis-category-list">
  <a
    class="block typography category-modal-typography py-4"
    (click)="changeCategory(category.urlPart)"
    *ngFor="let category of categories; let i = index; trackBy: trackBy"
    [ngClass]="category.id == selectedCategory!.id ? 'green-basic' : 'black'"
    [attr.data-testid]="'category-counter-' + i"
  >
    {{ category.description }}
  </a>
</div>
